/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerGetLatestProcessingQueryResponse, DocumentUseCasesControllerGetLatestProcessingPathParams, DocumentUseCasesControllerGetLatestProcessingQueryParams, DocumentUseCasesControllerGetLatestProcessing400, DocumentUseCasesControllerGetLatestProcessing401, DocumentUseCasesControllerGetLatestProcessing403, DocumentUseCasesControllerGetLatestProcessing404 } from "../../models/documentUseCasesController/DocumentUseCasesControllerGetLatestProcessing";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentUseCasesControllerGetLatestProcessing } from "../../clients/document-use-casesService/documentUseCasesControllerGetLatestProcessing";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentUseCasesControllerGetLatestProcessingQueryKey = (id: DocumentUseCasesControllerGetLatestProcessingPathParams["id"], params: DocumentUseCasesControllerGetLatestProcessingQueryParams) => [{
  url: '/api/v1/documents/:id/latest-processing',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type DocumentUseCasesControllerGetLatestProcessingQueryKey = ReturnType<typeof documentUseCasesControllerGetLatestProcessingQueryKey>;
export function documentUseCasesControllerGetLatestProcessingQueryOptions(id: DocumentUseCasesControllerGetLatestProcessingPathParams["id"], params: DocumentUseCasesControllerGetLatestProcessingQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentUseCasesControllerGetLatestProcessingQueryKey(id, params);
  return queryOptions<DocumentUseCasesControllerGetLatestProcessingQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetLatestProcessing400 | DocumentUseCasesControllerGetLatestProcessing401 | DocumentUseCasesControllerGetLatestProcessing403 | DocumentUseCasesControllerGetLatestProcessing404>, DocumentUseCasesControllerGetLatestProcessingQueryResponse, typeof queryKey>({
    enabled: !!(id && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentUseCasesControllerGetLatestProcessing(id, params, config);
    }
  });
}

/**
 * @description Returns the most recent blocking processing workflow for a document; process types that do not block readiness are excluded. The per-workflow group, including those, is on processing-status.workflows. Use ?include=steps,jobs to get related processing steps and jobs.
 * @summary Get latest blocking processing for a document
 * {@link /api/v1/documents/:id/latest-processing}
 */
export function useDocumentUseCasesControllerGetLatestProcessing<TData = DocumentUseCasesControllerGetLatestProcessingQueryResponse, TQueryData = DocumentUseCasesControllerGetLatestProcessingQueryResponse, TQueryKey extends QueryKey = DocumentUseCasesControllerGetLatestProcessingQueryKey>(id: DocumentUseCasesControllerGetLatestProcessingPathParams["id"], params: DocumentUseCasesControllerGetLatestProcessingQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentUseCasesControllerGetLatestProcessingQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetLatestProcessing400 | DocumentUseCasesControllerGetLatestProcessing401 | DocumentUseCasesControllerGetLatestProcessing403 | DocumentUseCasesControllerGetLatestProcessing404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentUseCasesControllerGetLatestProcessingQueryKey(id, params);
  const query = useQuery({
    ...documentUseCasesControllerGetLatestProcessingQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentUseCasesControllerGetLatestProcessing400 | DocumentUseCasesControllerGetLatestProcessing401 | DocumentUseCasesControllerGetLatestProcessing403 | DocumentUseCasesControllerGetLatestProcessing404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}